import React from 'react';
import logo from '../assets/images/logo.svg';

const Logo = () => {
  return (
    <div className='logo-holder'><img src={logo} className="logo"></img></div>
  )
}

export default Logo